import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router';

import { getPreviewCourseContainers } from '../library.store/selectors';

import { ContainerBanner } from './__container-banner/course-container-list__container-banner';
import { CourseContainerHelpBanner } from './__help-banner/course-container-list__help-banner';

import './course-container-list.scss';

export const CourseContainerPreviewList = memo(function CourseContainerPreviewList() {
    const {
        params: { subject, grade },
    } = useRouteMatch<{ subject: string; grade: string }>();

    const data = useSelector((storeState) => getPreviewCourseContainers(storeState, { subject, grade: Number(grade) }));

    return (
        <div className="course-container-list">
            {data?.map((courseContainer) => (
                <ContainerBanner
                    courseContainer={courseContainer}
                    key={courseContainer.container.slug}
                    previewOnly={true}
                />
            ))}

            <CourseContainerHelpBanner />
        </div>
    );
});
